import { useContext } from 'react';
import { BaleOutboundContext } from './context';

export const useBaleOutboundContext = () => {
	const context = useContext(BaleOutboundContext);
	if (!context) {
		throw new Error('useBaleOutboundContext must be used within a BaleOutboundContextProvider');
	}
	return context;
};
